<template>
  <div>
      <dashboard-peserta></dashboard-peserta>
  </div>
</template>

<script>
import DashboardPeserta from './DashboardPeserta.vue'
import DashboardPemateri from './DashboardPemateri.vue'

export default {
  components: {
    DashboardPeserta,
    DashboardPemateri,
  },
  data: () => ({
  }),
  computed: {
    user() {
      return this.$store.getters.user
    },
  },
  methods: {
  },
}
</script>
